// Dados dos planos de preços
export interface PricingPlan {
  id: string;
  name: string;
  description: string;
  monthlyPrice: number;
  annualPrice: number;
  users: number;
  dataStorage: string;
  fileStorage: string;
  marketplaceImports: string;
  features: string[];
  ctaType: 'free' | 'sales';
  highlighted?: boolean;
}

export const pricingPlans: PricingPlan[] = [
  {
    id: 'mei',
    name: 'MEI',
    description: 'Ideal para quem está começando e emite poucas notas.',
    monthlyPrice: 0,
    annualPrice: 0,
    users: 1,
    dataStorage: '500 MB',
    fileStorage: '1 GB', // Estimativa para "5 anos" de armazenamento leve
    marketplaceImports: '0',
    features: [
      'Emissão de 1 NF por mês grátis',
      'Armazenagem de 5 anos (xml)',
      'Emissão prática de produto e serviço',
      'Suporte e onboarding facilitado',
    ],
    ctaType: 'free',
  },
  {
    id: 'mei-pro',
    name: 'MEI Pro',
    description: 'Para MEIs que precisam de um pouco mais de volume.',
    monthlyPrice: 19.90,
    annualPrice: 214.92, // 19.90 * 12
    users: 1,
    dataStorage: '1 GB',
    fileStorage: '2 GB',
    marketplaceImports: '50',
    features: [
      'Até 5 NFs por mês',
      'Relatórios gerenciais',
      'Cadastro de fornecedores e produtos',
      'Armazenagem segura',
      'Suporte e onboarding',
    ],
    ctaType: 'sales',
    highlighted: false,
  },
  {
    id: 'pme',
    name: 'PME',
    description: 'Pequenas empresas com movimento regular.',
    monthlyPrice: 59.90,
    annualPrice: 646.92, // 59.90 * 12
    users: 3,
    dataStorage: '2 GB',
    fileStorage: '5 GB',
    marketplaceImports: '200',
    features: [
      'Até 50 NFs por mês',
      'Emissão de Produto e Serviço',
      'Sistema prático e fácil',
      'Relatórios completos',
      'Cadastro de fornecedores',
      'Suporte continuado',
    ],
    ctaType: 'sales',
    highlighted: true,
  },
  {
    id: 'pme-pro',
    name: 'PME Pro',
    description: 'Para empresas em crescimento acelerado.',
    monthlyPrice: 159.90,
    annualPrice: 1726.92, // 159.90 * 12
    users: 5,
    dataStorage: '5 GB',
    fileStorage: '10 GB',
    marketplaceImports: '500',
    features: [
      'Até 300 NFs por mês',
      'NFs recorrentes automáticas',
      'Modelos pré-setados de NFs',
      'Consultoria com gestor financeiro',
      'Relatórios avançados',
      'Cadastro completo de fornecedores',
    ],
    ctaType: 'sales',
  },
  {
    id: 'enterprise',
    name: 'Grandes Volumes',
    description: 'Soluções personalizadas para sua operação.',
    monthlyPrice: 0, // Sob consulta
    annualPrice: 0,
    users: 10,
    dataStorage: 'Sob demanda',
    fileStorage: 'Sob demanda',
    marketplaceImports: 'Ilimitado',
    features: [
      'Acima de 300 NFs mês',
      'Atendimento prioritário',
      'API Dedicada',
      'Customizações sob demanda',
    ],
    ctaType: 'sales', // Vai direcionar para contato
  },
];
